import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, 
    Button,
    Label, Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { Link, Redirect } from "react-router-dom"
import { Preview } from '../../../../../helpers/ui/FileInput'

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'
import Shimmer from 'react-shimmer-effect'
import CancelModal from './Components/CancelModal'
import IndexBloc from '../Index/Blocs/IndexBloc'
import DetailBloc from './Blocs/DetailBloc'
import { accessRole } from '../../../../../helpers/access_role'

const satuanWaktu = [
    { value: 'Hari', label: 'Hari'},
    { value: 'Minggu', label: 'Minggu'},
    { value: 'Bulan', label: 'Bulan' },
]

const reformatDate = (date, withDay = false) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
    ]
    
    const d = new Date(date);

    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    let day = ''
    if (withDay) {
        day = days[d.getDay()] + ", "
    }

    if (date) {
        return day + dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};

class DetailView extends Component {

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = this.userdata != null ? this.userdata.employee_uuid : ""

    queryParams = new URLSearchParams(window.location.search)

    source
    indexBloc = new IndexBloc()
    detailBloc = new DetailBloc()
    timer

    constructor(props) {
        super(props)
        this.state = {
            modal: false,
            detail: null,
            cancelUuid: null,
            typeOption: [],
            signatoriesOption: [],
            kuota: [],
            pembatalan: [],
            typeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'paid_leave_type_id',
                    order: 'asc' 
                }
            },
            signatoriesFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'signatories_official_id',
                    order: 'asc' 
                }
            } 
        }
    }

    toggle = () => {
        this.setState({ modal: !this.state.modal })
    }

    handlerOnSubmit = () => {
        this.setState({
            dataForm: {
              uuid: this.props.uuid,
            },
            confirm: true
        })
    }

    submitData = async () => {
        await this.detailBloc.fetchCancel(this.state.dataForm)
    }


    confirmResponse = (response) => {
        let forState = {}

        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadSignatoriesList = async () => {
        let offset = (this.state.signatoriesFilter.page_number-1)*this.state.signatoriesFilter.page_size
        const query = {
            search: this.state.signatoriesFilter.filter_value,
            limit: this.state.signatoriesFilter.page_size,
            offset: offset,
            order: this.state.signatoriesFilter.sort_order.column,
            sort: this.state.signatoriesFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchSignatoriesList(query, this.source.token)
    }

    loadTypeList = async () => {
        let offset = (this.state.typeFilter.page_number-1)*this.state.typeFilter.page_size
        const query = {
            search: this.state.typeFilter.filter_value,
            limit: this.state.typeFilter.page_size,
            offset: offset,
            order: this.state.typeFilter.sort_order.column,
            sort: this.state.typeFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchTypeList(query, this.source.token)
    }

    loadDetail = async () => {
        const query = { 
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    loadKuota = async (employee_uuid) => {
        await this.indexBloc.fetchKuotaTahunan({ uuid: employee_uuid })
    }

    cekWaktuCuti = (detail) => {
        const presensi = detail?.presensi
        let ketersediaan = []
        if (presensi) {
            presensi.forEach(element => {
                if (element.presensi_time_in != null || element.presensi_time_out != null) {
                    ketersediaan.push(element)
                }
            });
        }
        this.setState({ pembatalan: ketersediaan })
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadTypeList()
        this.loadSignatoriesList()
        this.loadDetail()
        // this.loadKuota()
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)

        this.state.signatoriesFilter.filter_value = value

        this.timer = setTimeout(() => this.loadSignatoriesList(), 800);
    }

    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.kuotaChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ kuota: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.detailBloc.cancelChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    if (result.data.response?.paid_leave_approval_status) {
                        this.cekWaktuCuti(result.data.response)
                    }
                    // if (result.data.response?.paid_leave_employee_uuid) {
                    //     this.loadKuota(result.data.response?.paid_leave_employee_uuid)
                    // }
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ typeOption: result.data.response.result })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.signatoriesChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ signatoriesOption: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.modal != this.state.modal) {
            if (!this.state.modal) {
                this.setState({ detailUuid: null })
            }
        }
    }

    componentWillUnmount = () => {
        this.indexBloc.kuotaChannel?.unsubscribe()
        this.indexBloc.cancelChannel?.unsubscribe()
        this.indexBloc.detailChannel?.unsubscribe()
        this.indexBloc.typeChannel?.unsubscribe()
        this.indexBloc.signatoriesChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state
        let sisaCutiTahunIni = 0;
        if (this.state.kuota) {
            let sisaCuti = 0;
            sisaCuti = (this.state.kuota?.oneYearBefore > 6 ? 6 : this.state.kuota?.oneYearBefore) + (this.state.kuota?.twoYearBefore > 6 ? 6 : this.state.kuota?.twoYearBefore)
            if (sisaCuti > 6) {
                sisaCuti = 6
            }
            sisaCutiTahunIni = this.state.kuota?.yearNow + sisaCuti;
            if (sisaCutiTahunIni < 0) {
                sisaCutiTahunIni = 0
            }
        }

        let back_link = `/izinpegawai/cuti.html`;
        if (this.queryParams.get('ref') != null) {
            back_link = `/izinpegawai/cuti.html?${this.queryParams.get('ref')}`;
        }

        return (

            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        {/* { detail?.paid_leave_diff <= 3 && detail?.paid_leave_approval_status == 1 && accessRole('approve') == false && */}
                                        { detail?.paid_leave_diff <= 3 && detail?.paid_leave_approval_status == 1 && accessRole('approve') == true &&
                                            <Button 
                                                style={{ marginRight: 5 }} 
                                                color="danger" 
                                                onClick={() => { 
                                                    this.setState({cancelUuid: this.props.uuid})
                                                    this.toggle();
                                                }}>
                                                <i className="uil uil-user-times"></i> Pengajuan Pembatalan
                                            </Button>
                                        }
                                        <Link to={back_link}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Detail Pengajuan Cuti</CardTitle>
                                    <hr />
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Nama Atasan
                                        </Label>
                                        <Col md="4">
                                            { detail ? 
                                                <Label className="col-form-label">
                                                    {detail?.paid_leave_leader_name}
                                                </Label>
                                                :
                                                <Shimmer>
                                                    <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                </Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Jenis Cuti
                                        </Label>
                                        <Col md="4">
                                            { detail ? 
                                                <Label className="col-form-label">
                                                    {detail?.paid_leave_type_full_name}
                                                </Label>
                                                :
                                                <Shimmer>
                                                    <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                </Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    {/* { detail?.paid_leave_type_uuid === 'b490a04a-0362-489b-832a-29e4c3b961bc' &&
                                        <Fragment>
                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Informasi Sisa Cuti Tahunan
                                                </Label>
                                                <Col md="3">
                                                    <Table>
                                                        <thead>
                                                            <tr>
                                                                <th>Tahun</th>
                                                                <th>Sisa</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>{new Date().getFullYear() - 2}</td>
                                                                <td>{this.state.kuota?.twoYearBefore}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>{new Date().getFullYear() - 1}</td>
                                                                <td>{this.state.kuota?.oneYearBefore}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>{new Date().getFullYear()}</td>
                                                                <td>{this.state.kuota?.yearNow}</td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td>
                                                                    {sisaCutiTahunIni}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        </Fragment>
                                    } */}



                                    { detail?.paid_leave_type_uuid == '2472b11b-6e1d-4f53-a49c-7c13d6477cb7' &&
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                            </Label>
                                            <Col md="4">
                                                { detail ? 
                                                    <Label className="col-form-label">
                                                        {detail?.paid_leave_category == 1 ? 'Rawat Inap' : 'Rawat Jalan'}
                                                    </Label>
                                                    :
                                                    <Shimmer>
                                                        <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                    </Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                    }

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Tanggal Mulai Cuti
                                        </Label>
                                        <Col md="4">
                                            { detail ? 
                                                <Label className="col-form-label">
                                                    {reformatDate(detail?.paid_leave_start_date)}
                                                </Label>
                                                :
                                                <Shimmer>
                                                    <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                </Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Tanggal Selesai Cuti
                                        </Label>
                                        <Col md="4">
                                            { detail ? 
                                                <Label className="col-form-label">
                                                    {reformatDate(detail?.paid_leave_end_date)}
                                                </Label>
                                                :
                                                <Shimmer>
                                                    <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                </Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Alasan Cuti
                                        </Label>
                                        <Col md="4">
                                            { detail ? 
                                                <Label className="col-form-label">
                                                    {detail?.paid_leave_reason}
                                                </Label>
                                                :
                                                <Shimmer>
                                                    <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                </Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Alamat Selama Menjalankan Cuti
                                        </Label>
                                        <Col md="4">
                                            { detail ? 
                                                <Label className="col-form-label">
                                                    {detail?.paid_leave_address}
                                                </Label>
                                                :
                                                <Shimmer>
                                                    <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                </Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            No Telepon Selama Cuti
                                        </Label>
                                        <Col md="4">
                                            { detail ? 
                                                <Label className="col-form-label">
                                                    {detail?.paid_leave_phone}
                                                </Label>
                                                :
                                                <Shimmer>
                                                    <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                </Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-2">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            File Pendukung
                                        </Label>
                                        <Label
                                            className="col-md-5 col-form-label"
                                        >
                                            { detail ? 
                                                <Preview value={detail?.document} />
                                                :
                                                <Shimmer>
                                                    <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                </Shimmer>
                                            }
                                        </Label>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Detail Tanggal Cuti
                                        </Label>
                                        <Col md="4">
                                            <Table className='table-striped table-bordered'>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '50px' }}>No</th>
                                                        <th>Hari, Tanggal</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                { detail ? 
                                                    detail?.details?.map((val, i) => {
                                                        return (
                                                            <tr>
                                                                <td className="text-center">{i + 1}</td>
                                                                <td>{reformatDate(val.paid_leave_detail_date, true)}</td>
                                                                <td className="text-center">{val.paid_leave_detail_status_name}</td>
                                                            </tr>
                                                        )
                                                    })
                                                    : 
                                                    <tr>
                                                        <td colSpan={2}>
                                                            <Shimmer>
                                                                <div style={{ width: "400px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                            marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                            </Shimmer>
                                                        </td>
                                                    </tr>
                                                }
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Status
                                        </label>
                                        <Col md="9">
                                            {
                                                detail ?
                                                    <>
                                                        {
                                                            detail.paid_leave_approval_status_name !== "" ? 
                                                                <label className={`badge rounded-pill ${(detail.paid_leave_approval_status==1?'bg-success':(detail.paid_leave_approval_status==2?'bg-danger':'bg-default'))} font-size-12`}>{detail.paid_leave_approval_status_name}</label>
                                                            : '-'
                                                        }
                                                    </>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                            {/* {
                                (detail && detail.paid_leave_approval_status == 2) ?
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Alasan Penolakan
                                        </label>
                                        <Col md="9">
                                            {
                                                detail ?
                                                    <>
                                                        {
                                                            detail.paid_leave_note !== "" ? 
                                                                detail.paid_leave_note
                                                            : '-'
                                                        }
                                                    </>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    :''
                            } */}
                            {
                                (detail && detail.paid_leave_approval_status == 2) ?
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Alasan Penolakan
                                        </label>
                                        <Col md="9">
                                            {
                                                detail ?
                                                    <>
                                                        {
                                                            detail.paid_leave_refusal_reason !== "" ? 
                                                                detail.paid_leave_refusal_reason
                                                            : '-'
                                                        }
                                                    </>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    :''
                            }
                                    {/* {detail?.paid_leave_approval_status == 4 &&
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Pembatalan Cuti
                                            </Label>
                                            <Col md="8">
                                                <Table>
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            <th>Tanggal</th>
                                                            <th>Jam Masuk</th>
                                                            <th>Jam Keluar</th>
                                                            <th>Keterangan</th>
                                                            <th>Dibatalkan?</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {detail?.presensi?.map((val, i) => {
                                                            let catatan = 'Waktu cuti sudah terpakai'
                                                            let pembatalan = false

                                                            const p = new Date(val.presensi_result_date)
                                                            const d = new Date()
                                                            
                                                            if (val.presensi_result_type == 2) {
                                                                catatan = 'Dinas'
                                                            }

                                                            if (val.presensi_result_workin !== null || val.presensi_result_workin !== null) {
                                                                pembatalan = true
                                                                catatan = 'Terdapat absen masuk/keluar'
                                                            }
                                                            if (p >= d) {
                                                                pembatalan = true
                                                                catatan = 'Tanggal cuti masih belum terlewat'
                                                            }
                                                            return (
                                                                <tr>
                                                                    <td className="text-center">{i + 1}</td>
                                                                    <td>{reformatDate(val.presensi_result_date, true)}</td>
                                                                    <td>
                                                                        {
                                                                            val.presensi_result_workin ? val.presensi_result_workin : '-'
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            val.presensi_result_workout ? val.presensi_result_workout : '-'
                                                                        }
                                                                    </td>
                                                                    <td>{catatan}</td>
                                                                    <td>{pembatalan ? 'Ya' : 'Tidak'}</td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    } */}

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>


                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={'/izinpegawai/cuti.html'} />
                : null }

                <CancelModal modal={this.state.modal} toggle={() => this.toggle()} uuid={this.state.cancelUuid} reload={()=>this.loadDetail()} />
            </Fragment>
        )
    }

}

export default DetailView 